import { EInfrastructureActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setActiveType = actionGenerator<EInfrastructureActionType.SetActiveType, number | undefined>(
  EInfrastructureActionType.SetActiveType,
);
